var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ReportTemplate',{attrs:{"loading":!_vm.initialized,"title":"Customer Report","permission":_vm.PERMISSION_CODES.CMS_VIEW_REPORT_CUSTOMER,"filters":_vm.filters,"columns":_vm.columns,"fetchRoute":"/reports/customers","reportTypeCode":_vm.REPORT_MASTER_CODES.CUSTOMER_LIST}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }